const state = {
  id: 0,
  username: '',
  points:0
}

const getters = {
  isLogin (state) {
    return typeof state.id !== 'undefined' && state.id !== 0;
  }
}

const actions = {}

const mutations = {
  setUser (state, user) {
    state.id = user.id
    state.username = user.username
    state.points = user.points
  },
  setPoints(state, points){
    state.points = points
  },
  logout (state) {
    state.id = 0
    state.username = ''
    state.points = 0
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
